import { CSSObject } from '@emotion/react'

/* Styling for account image, username, name, time(?), and caret icon */
const getAccountHeaderWrapper = (isMobile: boolean): CSSObject => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  margin: isMobile ? '0 10px 0 10px' : '0 10px 0 10px',
})

/* Styling for account name */
const getAccountName = (isMobile: boolean): CSSObject => ({
  fontWeight: 'bolder',
  fontSize: '16px',
  margin: '0 0 0 10px',
  maxWidth: isMobile ? '265px' : 'unset',
  overflow: isMobile ? 'hidden' : 'inherit',
  textOverflow: isMobile ? 'ellipsis' : 'inherit',
})

const timestamp = {
  color: '#B5B5B5',
  fontSize: '15px',
  marginRight: '15px',
}

const metaWrapper = {
  display: 'flex',
  marginRight: '5px',
  svg: {
    height: '14px',
    width: '14px',
  },
}

const styles = {
  getAccountHeaderWrapper,
  getAccountName,
  timestamp,
  metaWrapper,
}

export { styles }
